var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcAppRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1801 15.7692C12.4401 16.8591 11.6701 17.9491 10.4702 17.9791C9.28026 17.9991 8.9003 17.2591 7.55037 17.2591C6.20044 17.2591 5.7705 17.9491 4.65056 17.9991C3.49062 18.039 2.60063 16.8091 1.86067 15.7192C0.34075 13.4893 -0.819184 9.4095 0.740734 6.64965C1.09992 5.98666 1.62716 5.42977 2.26952 5.03488C2.91189 4.63998 3.64683 4.42095 4.40057 4.39977C5.54051 4.36977 6.62044 5.17973 7.3204 5.17973C8.02037 5.17973 9.3303 4.20978 10.7002 4.34977C11.2802 4.37977 12.9001 4.58976 13.94 6.13968C13.3571 6.50024 12.8758 7.00351 12.5416 7.60192C12.2074 8.20033 12.0314 8.87409 12.0302 9.5595C12.025 10.3317 12.2469 11.0883 12.6682 11.7355C13.0895 12.3826 13.6918 12.8916 14.4 13.1993C14.38 13.2693 14.03 14.4992 13.1801 15.7692ZM8.12035 1.35993C8.77824 0.58714 9.71019 0.0996421 10.7202 0C10.7994 1.03997 10.4693 2.06976 9.80025 2.86985C9.18028 3.63981 8.17034 4.22978 7.1804 4.14978C7.14305 3.64557 7.20701 3.13898 7.36844 2.65986C7.52986 2.18073 7.7855 1.73874 8.12035 1.35993Z",
    fill: "#FF1C44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAppRed);
export default __webpack_public_path__ + "static/media/ic_app_red.2cf75559e0f4bbc27357d37c44fcab00.svg";
export { ForwardRef as ReactComponent };